import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

/**
 * ein stern
 */

import Container = createjs.Container;

export class Poker2BanditStern extends Container {
    private STERNE_SPEED_Y: number = 4;		//	vorwärts
    private STERNE_SPEED_X: number = 4;		//	wackeln
    private STERNE_SPEED_A: number = .02;		//	lebensdauer
    private STERN_SPEED_ROTATION: number = 8;	//	drehen um sich selbst

    private stern: Container;

    constructor() {
        super();
        this.stern = new Library.PokerBandit.BanditSternGlow();
        this.addChild(this.stern);
    }

    public animation(): void {
        if (this.stern && this.stern.alpha > 0) {
            this.stern.y += Math.random() * this.STERNE_SPEED_Y;
            this.stern.x += this.STERNE_SPEED_X / 2 - Math.random() * this.STERNE_SPEED_X;
            this.stern.alpha -= this.STERNE_SPEED_A;
            this.stern.rotation += this.STERN_SPEED_ROTATION / 2 + Math.random() * this.STERN_SPEED_ROTATION;
        }
    }

    //
    // ende
    //
}
classImplementsInterfaces(Poker2BanditStern, "Container");
